/**
 * The state of one occurrence in a session's series: untouched, or carrying a
 * per-date override (cancelled / rescheduled / re-timed). Mirrors the backend
 * OccurrenceStatusResponse enum (PascalCase strings on the wire).
 */
export enum OccurrenceStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Rescheduled = "Rescheduled",
  Retimed = "Retimed",
}
